// reducers/getWBunitReducer.js
import dayjs from "dayjs";
import {   WB_UPDATE_ADPLAN_PERCENT_NM,
  WB_UPDATE_ADPLAN_PERCENT_ALL,
  WB_UPDATE_TAX_PERCENT_NM,
  WB_UPDATE_TAX_PERCENT_ALL,
  WB_UPDATE_COST_PRICE_NM,
  WB_UPDATE_COST_PRICE_ALL,
  WB_PATCH_COSTS_BY_NM } from "./action/action";




// Даты для API WB.
// Храним календарную дату без timezone-сдвига:
// date_from = начало дня, date_to = конец дня.
const dateToYmd = (value) => {
  if (!value) return "";

  if (dayjs.isDayjs(value)) {
    return value.format("YYYY-MM-DD");
  }

  if (value instanceof Date) {
    return dayjs(value).format("YYYY-MM-DD");
  }

  const raw = String(value).trim();
  if (!raw) return "";

  const match = raw.match(/^(\d{4})[.-](\d{2})[.-](\d{2})/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  const parsed = dayjs(raw);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

const toApiDateStartUTC = (value) => {
  const ymd = dateToYmd(value);
  return ymd ? `${ymd}T00:00:00.000+00:00` : "";
};

const toApiDateEndUTC = (value) => {
  const ymd = dateToYmd(value);
  return ymd ? `${ymd}T23:59:59.999+00:00` : "";
};

// базовый диапазон: вчера и 8 недель назад
const yesterday = dayjs().subtract(1, "day");
const eightWeeksAgo = yesterday.subtract(8, "week");

const initialState = {
  wnUnit: [],
  loading: false,
  error: null,
  currentPage: 1,
  itemsPerPage: 10,
  totalPages: 0,
  date_from: toApiDateStartUTC(eightWeeksAgo),
  date_to: toApiDateEndUTC(yesterday),
  searchValue: "",
  isAscending: false,      // направление сортировки
  sortedField: "count",    // поле сортировки
  summaryTotals: {
  skus: 0,
  sales: 0,
  revenue: 0,
  profit: 0,
},
summaryTotalsLoading: false,

unitTotal: {
  skus: 0,
  sales: 0,
  revenue: 0,
  profit: 0,
},
unitTotalLoading: false,
};

// округление до 2х знаков
const round2 = (x) => Math.round(Number(x) * 100) / 100;

const applyClientSort = (data, field, isAscending) => {
  if (!field) return data;

  const getVal = (obj, key) => {
    const v = obj?.[key];
    return v === undefined || v === null ? "" : v;
  };

  const arr = [...data];
  return arr.sort((a, b) => {
    const av = getVal(a, field);
    const bv = getVal(b, field);

    if (typeof av === "string" && typeof bv === "string") {
      return isAscending ? av.localeCompare(bv) : bv.localeCompare(av);
    }

    const an = Number(av);
    const bn = Number(bv);
    const bothNums = !Number.isNaN(an) && !Number.isNaN(bn);
    if (bothNums) return isAscending ? an - bn : bn - an;

    const as = String(av);
    const bs = String(bv);
    return isAscending ? as.localeCompare(bs) : bs.localeCompare(as);
  });
};

const getWBunitReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_WB_UNIT_REQUEST":
      return { ...state, loading: true, error: null };

    case "FETCH_WB_UNIT_SUCCESS": {
      const sortedData = applyClientSort(
        action.payload.data,
        state.sortedField,
        state.isAscending
      );
      return {
        ...state,
        loading: false,
        wnUnit: sortedData,
        totalPages: action.payload.totalPages,
      };
    }

    case "FETCH_WB_UNIT_FAILURE":
      return { ...state, loading: false, error: "error" };

    case "SET_PAGE_WBUNIT_TABLE":
      return { ...state, currentPage: action.payload.currentPage };

    case "REORDER_WB_UNIT":
      return { ...state, wnUnit: action.payload };

    case "SET_DATE_RANGE_WBUNIT": {
      const date_from = toApiDateStartUTC(action.payload.date_from);
      const date_to = toApiDateEndUTC(action.payload.date_to);
      return {
        ...state,
        date_from,
        date_to,
        wnUnit: [],
        currentPage: 1,
      };
    }

    case "CHANGE_SEARCH_VALUE_WB_UNIT":
      return { ...state, searchValue: action.payload };

    case "SORT_WB_UNIT": {
      const { field } = action.payload;
      const isAscending =
        state.sortedField === field ? !state.isAscending : true;
      const sorted = applyClientSort(state.wnUnit, field, isAscending);
      return { ...state, sortedField: field, isAscending, wnUnit: sorted };
    }

    case "FETCH_WB_UNIT_TOTALS_REQUEST":
  return {
    ...state,
    summaryTotalsLoading: true,
  };
case "FETCH_WB_UNIT_TOTAL_REQUEST":
  return {
    ...state,
    unitTotalLoading: true,
  };

case "FETCH_WB_UNIT_TOTAL_SUCCESS":
  return {
    ...state,
    unitTotalLoading: false,
    unitTotal: {
      skus: Number(action.payload.summary?.skus || 0),
      sales: Number(action.payload.summary?.sales || 0),
      revenue: Number(action.payload.summary?.revenue || 0),
      profit: Number(action.payload.summary?.profit || 0),
    },
  };

case "FETCH_WB_UNIT_TOTAL_FAILURE":
  return {
    ...state,
    unitTotalLoading: false,
  };
case "FETCH_WB_UNIT_TOTALS_SUCCESS":
  return {
    ...state,
    summaryTotalsLoading: false,
    summaryTotals: {
      skus: Number(action.payload.summary?.skus || 0),
      sales: Number(action.payload.summary?.sales || 0),
      revenue: Number(action.payload.summary?.revenue || 0),
      profit: Number(action.payload.summary?.profit || 0),
    },
    totals: action.payload.totals || {},
    totalElements: action.payload.totalElements || 0,
  };

case "FETCH_WB_UNIT_TOTALS_FAILURE":
  return {
    ...state,
    summaryTotalsLoading: false,
  };

    case "SET_EMPTY_ARRAY_WB_UNIT":
      return { ...state, wnUnit: [], currentPage: 1 };

    // ====== WB socket/inline updates ======

    case WB_UPDATE_COST_PRICE_NM: {
      const { nmID, amount } = action.payload || {};
      const next = state.wnUnit.map((row) => {
        const key = String(row._id ?? row.nmID);
        if (key !== String(nmID)) return row;
        return {
          ...row,
          // UI читает constPrice
          constPrice: Number(amount),
          costEdited: true,
        };
      });
      return {
        ...state,
        wnUnit: applyClientSort(next, state.sortedField, state.isAscending),
      };
    }

    case WB_UPDATE_COST_PRICE_ALL: {
      const { amount } = action.payload || {};
      const next = state.wnUnit.map((row) => ({
        ...row,
        constPrice: Number(amount),
        costEdited: true,
      }));
      return {
        ...state,
        wnUnit: applyClientSort(next, state.sortedField, state.isAscending),
      };
    }

    case WB_UPDATE_ADPLAN_PERCENT_NM: {
      const { nmID, adPlanPercent, adPlanEdited } = action.payload || {}; // доля 0..1
      const next = state.wnUnit.map((row) => {
        const key = String(row._id ?? row.nmID);
        if (key !== String(nmID)) return row;

        const price = Number(row.price) || 0;
        const share = Number(adPlanPercent) || 0;

        return {
          ...row,
          adPlanEdited: !!adPlanEdited,
          adPercent100: round2(share * 100),   // для инпута
          advertising: round2(price * share),  // ₽ на кнопку
        };
      });
      return {
        ...state,
        wnUnit: applyClientSort(next, state.sortedField, state.isAscending),
      };
    }

    case WB_UPDATE_ADPLAN_PERCENT_ALL: {
      const { adPlanPercent, adPlanEdited } = action.payload || {};
      const share = Number(adPlanPercent) || 0;
      const next = state.wnUnit.map((row) => {
        const price = Number(row.price) || 0;
        return {
          ...row,
          adPlanEdited: !!adPlanEdited,
          adPercent100: round2(share * 100),
          advertising: round2(price * share),
        };
      });
      return {
        ...state,
        wnUnit: applyClientSort(next, state.sortedField, state.isAscending),
      };
    }

    case WB_UPDATE_TAX_PERCENT_NM: {
      const { nmID, taxPercent, taxEdited } = action.payload || {}; // доля 0..1
      const next = state.wnUnit.map((row) => {
        const key = String(row._id ?? row.nmID);
        if (key !== String(nmID)) return row;

        const price = Number(row.price) || 0;
        const share = Number(taxPercent) || 0;

        return {
          ...row,
          taxEdited: !!taxEdited,
          taxPercent100: round2(share * 100), // для инпута
          tax: round2(price * share),         // ₽ на кнопку
        };
      });
      return {
        ...state,
        wnUnit: applyClientSort(next, state.sortedField, state.isAscending),
      };
    }

    case WB_UPDATE_TAX_PERCENT_ALL: {
      const { taxPercent, taxEdited } = action.payload || {};
      const share = Number(taxPercent) || 0;
      const next = state.wnUnit.map((row) => {
        const price = Number(row.price) || 0;
        return {
          ...row,
          taxEdited: !!taxEdited,
          taxPercent100: round2(share * 100),
          tax: round2(price * share),
        };
      });
      return {
        ...state,
        wnUnit: applyClientSort(next, state.sortedField, state.isAscending),
      };
    }

    case WB_PATCH_COSTS_BY_NM: {
      const updates = action.payload || []; // [{ nmID, amount }, ...]
      if (!Array.isArray(updates) || !updates.length) return state;

      const byNm = new Map(
        updates.map((u) => [String(u.nmID), Number(u.amount)])
      );

      const next = state.wnUnit.map((row) => {
        const key = String(row._id ?? row.nmID);
        if (!byNm.has(key)) return row;
        const amount = byNm.get(key);
        return { ...row, constPrice: amount, costEdited: true };
      });

      return {
        ...state,
        wnUnit: applyClientSort(next, state.sortedField, state.isAscending),
      };
    }

    default:
      return state;
  }
};

export default getWBunitReducer;
